<template>
  <div class="delivery">
      <h5>
          請選擇適合你的送貨方法:
      </h5>
      <div class="select" @click="next('orderForm','self')">
          <div>
              <h4>自取</h4>
              <h6>可選擇自取</h6>
          </div>
          <div class="el-icon-arrow-right"></div>
      </div>
      <div class="select" @click="next('orderForm','delivery')">
          <div>
              <h4>送貨</h4>
              <h6>免運費／按地區收取運費</h6>
          </div>
          <div class="el-icon-arrow-right"></div>
      </div>
  </div>
</template>
<script>
export default {
    methods:{
        next(value,way){
            this.$emit('updateCom',value,way)
        }
    }
}
</script>
<style scoped>
.delivery {
  padding: 3rem 1rem;
}
.delivery > h5{
    padding: 1rem 0;
    text-align: center;
}
.delivery > .select {
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    box-shadow:0 5px 10px hsl(0deg 0% 43% / 30%);
    padding: 0.5rem;
    font-weight: 700;
    margin: 1rem 0;
    cursor: pointer;
    border-radius: .25rem;
}
.delivery > .select h4{
    margin: .5rem 0;
}

</style>
